import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { RollOperation } from "../models/Operation";

const moment = getMomentTz();

export const getRollOperations = async (
	params?: { partId?: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params?.partId) {
		parameters.push({ name: "PartId", value: params.partId });
	}

	const resp = await apiService.callV2(
		"[M2].[GetRollsOperations]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []);

		rows = rows.map((operation: RollOperation) => ({
			...operation,
			OperationTimestamp: operation.OperationTimestamp
				? moment.utc(operation["OperationTimestamp"]).toDate()
				: null,
		}));

		return rows as RollOperation[];
	} else {
		throw new Error(resp.message || "Error fetching rolls");
	}
};

type upsertRollOperationProps = {
	partId: number;
	timestamp: Date;
	operatorId: number | null;
	rollOperationTypeCode: string;
	comments: string;
};

export const upsertRollOperation = async ({
	partId,
	timestamp,
	operatorId,
	rollOperationTypeCode,
	comments,
}: upsertRollOperationProps) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "PartId", value: partId },
		{ name: "Timestamp", value: timestamp.toISOString() },
		{ name: "OperatorId", value: operatorId },
		{ name: "RollOperationTypeCode", value: rollOperationTypeCode },
		{ name: "Comments", value: comments },
	];

	const resp = await apiService.callV2(
		"[M2].[UpsertRollOperation]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting roll operation");
	}
};

type UpsertRollProps = {
	partId: number;
	locationId?: number | null;
	diameter?: number | null;
	statusCode?: string | null;
	standId?: number | null;
	comments?: string | null;
};

export const upsertRoll = async ({
	partId,
	locationId,
	diameter,
	statusCode,
	standId,
	comments,
}: UpsertRollProps) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [{ name: "PartId", value: partId }];

	if (locationId !== undefined) {
		parameters.push({ name: "LocationId", value: locationId });
	}
	if (diameter !== undefined) {
		parameters.push({
			name: "Diameter",
			value: typeof diameter === "string" ? parseFloat(diameter) : diameter,
		});
	}
	if (statusCode !== undefined) {
		parameters.push({
			name: "RollStatusCode",
			value: statusCode,
		});
	}
	if (standId !== undefined) {
		parameters.push({ name: "StandId", value: standId });
	}
	if (comments !== undefined) {
		parameters.push({ name: "Comments", value: comments });
	}

	const resp = await apiService.callV2("[M2].[UpsertRoll]", parameters);

	if (resp.ok) {
		return get(resp, "data.returnValue", null) as number;
	} else {
		throw new Error(resp.message || "Error upserting roll");
	}
};
